import { Permission } from '@/lib/permissions/v1'
import router from '@/router'
import { LocationQuery, useRoute, useRouter } from 'vue-router'

export enum BillingRouteName {
    Index = 'finance.billing.index',
}

export const goToBilling = (query?: LocationQuery) => {
    const route = router.currentRoute.value

    router.push({
        name: BillingRouteName.Index,
        params: {
            ...route.params,
        },
        query: {
            ...route.query,
            ...query,
        },
    })
}

export default {
    path: 'billing',
    name: BillingRouteName.Index,
    component: () => import('@/views/finance/billing/Index.vue'),
    meta: {
        label: 'Billing',
        auth: true,
        permission: Permission.InvoiceCreate,
    },
}
